

import React, { useState, useEffect } from 'react';
import './QcCmrOngoingInspectionToday.css';
import axios from "axios";
import { jsPDF } from 'jspdf';
import ExcelJS from 'exceljs';
import pds from './pds.PNG';
import { format } from 'date-fns';
const QCCmrOngoingInspectionToday = () => {

    const token = `${process.env.REACT_APP_AFTER_TOKEN}`;
    const baseUrl = `${process.env.REACT_APP_GODOWN_API_URL}/api`;
    const [stockData, setStockData] = useState([]);
    const fetchData = async () => {
        const todayDate = format(new Date(), 'yyyy-MM-dd');  // Format today's date as 'yyyy-MM-dd'
        
        try {
            const response = await axios.get(`${baseUrl}/ongoing/godown/3/date/${todayDate}`, {
                headers: {
                    Authorization: `Bearer ${token}`,  // Passing the token in the Authorization header
                }, 
            });

            // Check if the response data is an array and has data
            if (response.data && Array.isArray(response.data)) {
                setStockData(response.data);  // Set the data into the state
            }
        } catch (error) {
            console.error('Error fetching the data:', error);  // Handle errors
        }
    };

    // Use useEffect to trigger the fetchData method when the component is mounted
    useEffect(() => {
        fetchData();
    }, []);
    // const queryParams = new URLSearchParams(location.search);

    const downloadPDF = () => {
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.addImage(pds, 'PNG', 9, 1, 193, 36);  // Image format: 'PNG'
        doc.setFontSize(18);
        // doc.text('Ongoing Inspections Today', 60, 40);

        const currentDate = new Date();

        // Format the date as dd-mm-yyyy
        const day = String(currentDate.getDate()).padStart(2, '0'); // Get day and pad with zero if needed
        const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Get month (months are 0-indexed)
        const year = currentDate.getFullYear(); // Get the year

        const formattedDate = `${day}-${month}-${year}`; // Format as dd-mm-yyyy

        // Now use the formatted date in doc.text()
        doc.text(`QC-CMR Ongoing Inspections Today ${formattedDate}`, 44, 40);


        let currentYPosition = 44;


        // // Get the current date and time
        /// const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        //   const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;

        // Set the date text color (black) and make it bold
        doc.setFont('helvetica', 'bold'); // Use Helvetica font and bold style
        doc.setTextColor(0, 0, 0);  // Black color for the date
        doc.setFontSize(12);

        // Set the position for the current date and time
        // const dateYPosition = titleYPosition+35; // Position the date just below the title

        // Add the current date and time to the PDF, positioned at the bottom-right corner
        doc.text(`Report Date: ${formattedDateTime}`, 196, currentYPosition + 3, { align: 'right' });
        currentYPosition += 5;


        let currentXPosition = 20;
        const headers = ['S.No', 'District', 'Sub-Division', 'Block', 'Panchayat', 'Godown ID', 'Inspecting Officer', 'Inspecting Date'];
        const rows = stockData.map((data, index) => [
            index + 1,
            capitalizeFirstLetter(data.district?.districtName || 'N/A'),
            capitalizeFirstLetter(data.subDivision?.subDivisionName || 'N/A'),
            capitalizeFirstLetter(data.block?.blockName || 'N/A'),
            capitalizeFirstLetter(data.panchayat?.panchayatName || 'N/A'),
            data.godown?.godownId || 'N/A',
            data.poimsUser?.fullname || 'N/A',
            format(new Date(data.createdAt), 'dd-MM-yyyy'),
        ]);

        doc.autoTable({
            head: [headers],
            body: rows,
            startY: currentYPosition,
            startX: currentXPosition,
            theme: 'grid',
            columnStyles: {
                0: { cellWidth: 12, halign: 'center' },  // S.No - Center alignment
                1: { cellWidth: 20, halign: 'left' },    // District - Left alignment
                2: { cellWidth: 25, halign: 'left' },    // Subdivision - Left alignment
                3: { cellWidth: 25, halign: 'left' },    // Block Name - Left alignment
                4: { cellWidth: 25, halign: 'left' },    // Panchayat Name - Left alignment
                5: { cellWidth: 25, halign: 'right' },   // FPS ID - Right alignment
                6: { cellWidth: 30, halign: 'left' },   // Start Time - Right alignment
                7: { cellWidth: 25, halign: 'right' },    // POIMS User - Left alignment
            },
            tableWidth: 'auto',
            margin: {
                horizontal: 10,
                top: 10,
                bottom: 10,
            },
            pageBreak: 'auto',
            showHead: 'firstPage',
            styles: {
                fontSize: 10,
                textColor: 0,
            },
            headStyles: {
                fontSize: 10,
                fontStyle: 'bold',
                textColor: [42, 109, 139],
                fillColor: [211, 211, 211],
            }
        });
        doc.save('qc_cmr_ongoning_inspection_today.pdf');
    };
    // Function to download the table as an Excel file
    const downloadExcel = () => {
        const workbook = new ExcelJS.Workbook();
        const currentDate = new Date();

        // Format the current date as dd-mm-yyyy
        const day = String(currentDate.getDate()).padStart(2, '0'); // Get day and pad with zero if needed
        const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Get month (months are 0-indexed)
        const year = currentDate.getFullYear(); // Get the year

        const formattedDate = `${day}-${month}-${year}`; // Format as dd-mm-yyyy

        // Create a worksheet with the formatted date in its title
        const worksheet = workbook.addWorksheet(`CMR Ongoing Inspections On ${formattedDate}`);
        worksheet.mergeCells('A1:H1'); // Merge cells for the title
        worksheet.getCell('A1').value = `QC-CMR Ongoing Inspections On ${formattedDate}`;
        worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getRow(1).font = { bold: true, size: 12 };
        worksheet.getRow(1).alignment = { horizontal: 'center' };
        worksheet.getRow(1).font = { size: 16, bold: true, color: { argb: 'F7912B' } };   // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getRow(1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' },
            color: { argb: 'F7912B' }  // Background color: Whitesmoke (ARGB format)
        };



        // const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        //  const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;
        worksheet.mergeCells('A2:H2'); // Merge cells for the title
        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;
        worksheet.getCell('A2').value = `Report Date :  ${formattedDateTime}`;
        worksheet.getRow(2).font = { bold: true, size: 12 };
        worksheet.getRow(2).alignment = { horizontal: 'right' };
        worksheet.getRow(2).font = { size: 11, bold: true, color: { argb: '000000' } };   // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getRow(2).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' },
            color: { argb: 'F7912B' }  // Background color: Whitesmoke (ARGB format)
        };
        // Set column headers
        worksheet.addRow(['S.No', 'District', 'Sub-Division', 'Block', 'Panchayat', 'Godown ID', 'Inspecting Officer', 'Inspecting Date']);

        // Apply header style: bold, size 12, and orange background


        // Apply background color to the first 6 cells of the header row
        for (let col = 1; col <= 8; col++) {
            const cell = worksheet.getCell(3, col); // Get each cell in the first row (header)
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' }  // Orange background color
            };
            // Apply font styling: bold and size 12
            cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
            // Add border to header cells
            cell.border = {
                top: { style: 'thin', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'thin', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } }
            };
        }

        // Adjust column widths
        worksheet.columns = [
            { key: 'A', width: 10 },  // Column A width
            { key: 'B', width: 20 },  // Column B width
            { key: 'C', width: 20 },  // Column C width
            { key: 'D', width: 20 },  // Column D width
            { key: 'E', width: 20 },  // Column E width
            { key: 'F', width: 15 },  // Column F width
            { key: 'G', width: 25 },  // Column D width
            { key: 'H', width: 18 },  // Column E width
            // { key: 'I', width: 25 },
        ];

        // Add data rows from stockData
        stockData.forEach((data, index) => {
            const dataRow = worksheet.addRow([
                index + 1, // S.No
                capitalizeFirstLetter(data.district?.districtName || 'N/A'),
                capitalizeFirstLetter(data.subDivision?.subDivisionName || 'N/A'),
                capitalizeFirstLetter(data.block?.blockName || 'N/A'),
                capitalizeFirstLetter(data.panchayat?.panchayatName || 'N/A'),
                data.godown?.godownId || 'N/A',
                data.poimsUser?.fullname || 'N/A',
                format(new Date(data.createdAt), 'dd-MM-yyyy'),

                // 'View Report' // Placeholder or dynamic link
            ]);

            // Adjust alignment for 'fpsId' (column 6) and 'startTime' (column 7) and center 'S.No' (column 0)
            dataRow.eachCell((cell, colNumber) => {
                if (colNumber === 1) {  // Column 0 (S.No)
                    cell.alignment = { horizontal: 'center' };  // Center align for S.No
                } else if (colNumber === 6 || colNumber === 8) {  // Columns 6 (fpsId) and 7 (startTime)
                    cell.alignment = { horizontal: 'right' };  // Right align for fpsId and startTime
                } else {
                    cell.alignment = { horizontal: 'left' };  // Left align for all other columns
                }
            });

        });
        // Write Excel file to a buffer
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'QC_CMR_ongoing_inspection_today.xlsx';
            link.click();
        });
    };
    const capitalizeFirstLetter = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    return (
        <div className="QCCmrOngoingInspectionToday">
            <div className="QCCmrOngoingInspectionToday-repo">
                <div className="QCCmrOngoingInspectionToday-header-15">
                    <button className="QCCmrOngoingInspectionToday-btn" onClick={downloadPDF}>DOWNLOAD PDF</button>
                    <button className="QCCmrOngoingInspectionToday-btn" onClick={downloadExcel}>DOWNLOAD XLSX</button>
                </div>
                <div className='CmrongoingIn-text'><h3>QC-CMR Ongoing Inspections</h3></div>
                <div className="QCCmrOngoingInspectionToday-scroll">
                    <div className="QCCmrOngoingInspectionToday-table-wrapper">
                        <table className="QCCmrOngoingInspectionToday-table">
                            <thead>
                                <tr className="QCCmrongoingInspection-tr">
                                    <th>S.No</th>
                                    <th>District</th>
                                    <th>Sub-Division</th>
                                    <th>Block</th>
                                    <th>Panchayat</th>
                                    <th>Godown ID</th>
                                    <th>Inspecting Officer</th>
                                    <th>Inspection Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {stockData.map((data, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{capitalizeFirstLetter(data.district?.districtName)}</td>
                                        <td>{capitalizeFirstLetter(data.subDivision?.subDivisionName)}</td>
                                        <td>{capitalizeFirstLetter(data.block?.blockName)}</td>
                                        <td>{capitalizeFirstLetter(data.panchayat?.panchayatName)}</td>
                                        <td>{data.godown?.godownId}</td>
                                        <td>{data.poimsUser?.fullname||"N/A"}</td>
                                        <td>{format(new Date(data.createdAt), 'dd-MM-yyyy')}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default QCCmrOngoingInspectionToday;
